import { getHebrewLetters, getEnglishLetters } from '@/classes/my_utils.js'
class FileHelper {
  getErrors (file_name) {
    let pass_array = []
    let hebrew_letters = getHebrewLetters()
    let english_letters = getEnglishLetters()
    let numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
    let hyphen = ['-', '_', '.']
    let space = [' ']
    pass_array = pass_array.concat(
      hebrew_letters,
      english_letters,
      numbers,
      hyphen,
      space
    )
    let file_errors = []
    for (let i = 0; i < file_name.length; i++) {
      let char = file_name.charAt(i).toLowerCase()
      if (!pass_array.includes(char) && !file_errors.includes(char)) {
        file_errors.push(char)
      }
    }
    return file_errors
  }

  isAuthorized (file_name) {
    return this.getErrors(file_name).length == 0
  }
}

export default FileHelper
